<template lang="html">
  <div id="article-page">

    <section class="header-banners-section-s2">
    </section>

    <section class="container main-section" data-aos="fade-in" data-aos-duration="1000">
      <div class="row">
        <div class="col-lg-7 mt-3 mt-lg-0 col-content">
          <div class="mb-2">
            <h1 class="title-s1">{{ article.name }}</h1>
          </div>

          <div class="box-content" v-html="article.body"></div>
        </div>

        <div class="col-lg-5 col-image">
          <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+article.image+')' }">
            <img src="public/images/shared/empty.png">
          </div>
        </div>
      </div>
    </section>

    <loading-bg-component v-if="isLoading"></loading-bg-component>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      
      article: {
        name: null,
        body: null,
        image:null,
      }
    }
  },

  methods: {
    getBlog(id) {
      this.isLoading = true;

      axios.post(tools.url('/api/blog/'+id)).then((response) =>{
        this.article = response.data;
        this.isLoading = false;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  beforeMount() {
    this.getBlog(this.$route.params.id);
  },
}
</script>
